import { Component, Input } from '@angular/core';
import { INotesMovementScheduleData } from '@modeso/aumico-lib-annualreport-fe';
import { IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';

@Component({
    selector: 'aumico-notes-movement-schedule-display',
    templateUrl: './notes-movement-schedule-display.component.html',
    styleUrls: ['./notes-movement-schedule-display.component.scss'],
})
export class NotesMovementScheduleDisplayComponent {
    @Input() set sectionNotes(value: INotesMovementScheduleData[][]) {
        this.sectionData = value;
    }
    @Input() set printOptionStyles(value: IPrintOptions | undefined) {
        if (value != null) {
            this.textColor = value.styleOptions.textColor;
            this.backgroundColor = value.styleOptions.backgroundColor;
            this.tableHeaderColor = value.styleOptions.tableHeaderColor;
            this.tableFooterColor = value.styleOptions.tableFooterColor;
        }
    }
    @Input() noPreviousData: boolean;

    textColor: string;
    tableFooterColor: string;
    tableHeaderColor: string;
    backgroundColor: string;
    public sectionData: INotesMovementScheduleData[][];
    constructor() {}
}
